import { render, staticRenderFns } from "./ItemProfileField.vue?vue&type=template&id=c950930e&scoped=true"
import script from "./ItemProfileField.vue?vue&type=script&lang=js"
export * from "./ItemProfileField.vue?vue&type=script&lang=js"
import style0 from "./ItemProfileField.vue?vue&type=style&index=0&id=c950930e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950930e",
  null
  
)

export default component.exports